module.exports = __webpack_public_path__ + "static/1-728f240be1c5a496764e8e0bf90e508e.png";